import React from 'react'
import VIDEO from '../assets/video/home.mp4'

const Home = () => {
  return (
    <div className='w-full lg:py-16 py-3 h-[100vh]' id='home'>
      <div className='video-container absolute inset-0'>
        <video className="object-cover w-full h-full" autoPlay loop muted>
          <source src={VIDEO} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <div className="content absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-white text-center z-10">
          <p className='text-3xl text-gray-200 mb-10 font-semibold'>Changing the world, one student at a time.</p>
          <p className='text-3xl text-gray-200 mb-10 font-semibold'>Your Success Story Starts Here!<br /></p>
          <a href='#aboutus'>
            <button type="button" className="text-white bg-gray-500 hover:bg-gray-800 hover:text-white focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800 mb-5">Explore More</button>
            
          </a>
        </div>
      </div>
    </div>
  )
}

export default Home